/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Merge_Event_Aria_LabelInputs */

const en_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Event`)
};

const fr_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner l'evenement`)
};

const de_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführungsereignis`)
};

const it_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci evento`)
};

const ru_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие слияния`)
};

const es_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento de fusión`)
};

const zh_cn2_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并事件`)
};

const ja_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マージイベント`)
};

const hi_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलय कार्यक्रम`)
};

const pt_pt2_timeline_merge_event_aria_label = /** @type {(inputs: Timeline_Merge_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento de Fusão`)
};

/**
* | output |
* | --- |
* | "Merge Event" |
*
* @param {Timeline_Merge_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_merge_event_aria_label = /** @type {((inputs?: Timeline_Merge_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Merge_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_merge_event_aria_label(inputs)
	if (locale === "de") return de_timeline_merge_event_aria_label(inputs)
	if (locale === "it") return it_timeline_merge_event_aria_label(inputs)
	if (locale === "ru") return ru_timeline_merge_event_aria_label(inputs)
	if (locale === "es") return es_timeline_merge_event_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_merge_event_aria_label(inputs)
	if (locale === "ja") return ja_timeline_merge_event_aria_label(inputs)
	if (locale === "hi") return hi_timeline_merge_event_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_merge_event_aria_label(inputs)
	return en_timeline_merge_event_aria_label(inputs)
});